<template>
    <sa-page-layout :btnBackVisible="false" :btnEditVisible="btnEditVisible" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <rsa-riepilogo-accessi-adi-list-component ref="cmpRsaRiepilogoAccessiAdiList" :idAccettazione="idAccettazione"></rsa-riepilogo-accessi-adi-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaRiepilogoAccessiAdiListComponent from "../../rsagestioneospiti/components/RsaRiepilogoAccessiAdiListComponent.vue";
export default {
    components: { SaPageLayout, RsaRiepilogoAccessiAdiListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "",
            btnEditVisible: false,
            showModalLoading: false,
            linkback: null,
            linkedit: null,
            idAccettazione: this.$route.query.idAccettazione || null,
        };
    },
    mounted() {
        let me = this;
        me.init();
    },
    methods: {
        init() {
            let me = this;
            me.$refs.cmpRsaRiepilogoAccessiAdiList.init(true);
        },
    },
};
</script>
<style></style>
